
import { onBeforeMount, ref } from "vue";
import ModernInput from "./modernInput.vue";
import { UserData } from "../../../../../domain/entities/entities";
import { disableBodyOverflow, enableBodyOverflow } from "../../mixins";

export default {
  name: "ResetPasswordComponent",
  components: { ModernInput },

  setup(_, { emit }) {
    const userData = ref(new UserData());

    onBeforeMount(() => disableBodyOverflow());

    const maskCPF = (event: Event): void => {
      const input = event.target as HTMLInputElement;

      if (input.value.includes("@")) {
        return;
      }

      input.value = maskedCPF(input.value);
    };

    const unmaskCPF = (event: Event): void => {
      const input = event.target as HTMLInputElement;

      if (input.value.includes("@")) {
        return;
      }

      input.value = input.value.replace(/(\.|\/|\-)/g, "");
    };

    const maskedCPF = (value: string): string => {
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
    };

    const submit = () => {
      if (userData.value.document.includes("@")) {
        emit("recoverByEmail", userData.value);
      } else {
        emit("recoverByDocument", userData.value);
      }
      enableBodyOverflow();
    };

    return {
      userData,
      maskCPF,
      unmaskCPF,
      submit
    };
  }
};
